import $ from 'jquery';
window.$ = window.jQuery = $;
// import 'slick-carousel';
import 'slick-carousel/slick/slick.min';

//  import test from './components/test';
import headerSticky from './components/headerSticky';
import scrollDown from './components/scrollDown';
import video from './components/video';
import slickSlider from './components/slick-slider';
import teamPopup from './components/teamPopup';
import map from './components/map';
import tabs from './components/tabs';
import menu from './components/main-menu';
import numberCount from './components/numberCount';
import accordion from './components/accordion';

$(function() {
    // Handler for .ready() called.
    // test.init()
    headerSticky.init();
    scrollDown.init();
    video.init();
    slickSlider.init();
    teamPopup.init();
    map.init();
    tabs.init();
    menu.init();
    numberCount.init();
    accordion.init();

		AOS.init({
			once: true,
			disable: window.innerWidth < 768,
		});
});